import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";

interface IRadioButtonControlPropsc2<TKey> {
    id?: string;
    htmlName: string;
    items: Immutable.List<KeyValuePair<TKey, string>>;
    title?: string;
    cssClass?: string;
    changeOperation?: number;
    onChangeCallback?: (value: KeyValuePair<TKey, string>) => void;
    selectedItem: any;
    minWidth?: number;
    styleForEachradio?: React.CSSProperties;
    wrapperClassName?: string
    disabled?: boolean;
    dataCy?: string;
}

class RadioButtonv2<TKey> extends React.Component<IRadioButtonControlPropsc2<TKey>, never> {
    private controlId: string;

    constructor(props: IRadioButtonControlPropsc2<TKey>) {
        super(props);

        if (this.props.id == null) {
            this.controlId = GuidHelper.NewGuid(); // generate self id
        }
        else {
            this.controlId = this.props.id;
        }
    }

    public render(): JSX.Element {
        var self = this;
        var title = null;
        var css = "radio";
        if (this.props.title != null) {
            title = <label className="ratio-title">{this.props.title}</label>;
        }

        if (this.props.cssClass != null) {
            css += (" " + this.props.cssClass);
        }

        var style = null;
        if (this.props.minWidth != null) { style = { minWidth: self.props.minWidth + "px" }; }

        let styleForEachradio = null;
        if (this.props.styleForEachradio != null) styleForEachradio = this.props.styleForEachradio;
        return (
            <div className={this.props.wrapperClassName ?? ""}>
                {title}
                <div style={style} className={css}>
                    {this.props.items.toArray().map((item, idx) => (
                        <div key={"_list_radioitem_" + self.controlId + "_" + idx} className="radio" style={styleForEachradio}>
                            <label htmlFor={idx + "_list_item_" + self.controlId}>
                                <input
                                    onChange={self.onSelectionChange.bind(self, item)}
                                    id={idx + "_list_item_" + self.controlId}
                                    type="radio"
                                    name={self.props.htmlName}
                                    value={item.Value}
                                    checked={self.props.selectedItem === item.Key}
                                    disabled={this.props.disabled}
                                    data-cy={this.props.dataCy ? `${this.props.dataCy}-radioButton-${item.Key}` : null}
                                />
                                {item.Value}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    public shouldComponentUpdate(nextProps: IRadioButtonControlPropsc2<TKey>): boolean {
        var val = nextProps.selectedItem !== this.props.selectedItem;
        var list = nextProps.items !== this.props.items;
        return val || list;
    }

    public onSelectionChange(item: KeyValuePair<TKey, string>): void {
        if (!!this.props.changeOperation) {
            sessionStore.dispatch(this.props.changeOperation, { "value": item });
        }

        if (this.props.onChangeCallback != null) {
            this.props.onChangeCallback(item);
        }
    }
}

export { RadioButtonv2 };
